import {NotificationInterface} from "../interfaces/notifications/NotificationInterface";
import {NotificationDataInterface} from "../interfaces/notifications/NotificationDataInterface";
import {DateTime} from "luxon";
import {setDates} from "../helpers/DatesSetter";

export class Notification implements NotificationInterface {
    body: string;
    createdAt: DateTime;
    data?: NotificationDataInterface;
    deepLink: string;
    id: string;
    isDeleted: boolean;
    isPublished: boolean;
    isRead: boolean;
    title: string;
    type: string;
    updatedAt: DateTime;
    updatedBy: number;

    constructor(data: NotificationInterface) {
        Object.assign(this, data);
        setDates(this, ['updatedAt', 'createdAt']);
    }

}